exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".shareResponse{position:absolute;left:15px;top:18px;z-index:1}.shareResponse img{width:40px;height:auto;display:block;margin-bottom:6px}.shareResponse .spinnerBox.placeholder{padding:20px}.shareResponse .loadingText{display:block;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/writing/responses/share_response.scss
// module id = 1505
// module chunks = 0